module.exports = __webpack_public_path__ + "img/wd.4bf3a59b.png";